import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { visibleFor } from "../lib/nav";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

const LOGO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_fleet-command-177/artifacts/ilhe4ttw_Velvet%20GPS%20Logo.jpeg";

export default function Sidebar() {
  const { user } = useAuth();
  const [rules, setRules] = useState({ labels: {}, hidden_paths: [] });
  useEffect(() => { api.get("/settings/rules").then((r) => setRules({ labels: {}, hidden_paths: [], ...r.data })).catch(() => {}); }, []);
  const isAdmin = ["super_admin", "oem_admin"].includes(user?.role);
  const sections = visibleFor(user?.role || "fleet_user")
    .map((s) => ({ ...s, items: s.items.filter((it) => isAdmin || !(rules.hidden_paths || []).includes(it.path)) }))
    .filter((s) => s.items.length);

  return (
    <aside className="w-60 shrink-0 bg-white border-r border-border h-screen flex flex-col"
           data-testid="sidebar">
      <div className="h-14 flex items-center gap-2.5 px-4 border-b border-border shrink-0">
        <div className="w-9 h-9 rounded-md bg-[#17263a] flex items-center justify-center overflow-hidden shrink-0">
          <img src={LOGO} alt="Velvet GPS" className="w-full h-full object-contain" />
        </div>
        <div className="leading-none">
          <div className="font-display font-black text-base tracking-tight text-[#17263a]">VELVET GPS</div>
          <div className="label-caps text-[9px] text-primary">AIS-140 Command</div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto py-3">
        {sections.map((s) => (
          <div key={s.section} className="mb-4">
            <div className="label-caps px-4 mb-1 text-[9px] text-muted-foreground">{s.section}</div>
            {s.items.map((it) => {
              const Icon = it.icon;
              return (
                <NavLink
                  key={it.path}
                  to={it.path}
                  end={it.path === "/"}
                  data-testid={`nav-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-4 py-2 text-sm transition-colors border-l-[3px] ${
                      isActive
                        ? "border-primary bg-accent text-accent-foreground font-semibold"
                        : "border-transparent text-[#44566d] hover:text-[#17263a] hover:bg-secondary"
                    }`
                  }
                >
                  <Icon size={17} weight="bold" />
                  {rules.labels?.[it.path] || it.label}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
}
